import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useSelector } from "react-redux"
import { useLazyGetInvestorUserQuery } from "store/api/investorapi/user.api"
import UsersInvestorForm from "./form"

const EditInvestorUsers = () => {
  const { id } = useParams()
  const [getUser, { isLoading }] = useLazyGetInvestorUserQuery()
  const [userData, setUserData] = useState()
  const [userStatus, setUserStatus] = useState()

  const { permissions } = useSelector((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.includes("USERS_UPDATE")
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  useEffect(() => {
    if (id) {
      const onGetUser = async () => {
        const { data } = await getUser({ id }).unwrap()
        setUserData({
          name: data.name,
          email: data.email,
          entity_type: data.entity_type,
          permissions: data.permissions,
        })
        setUserStatus(data.status)
      }
      onGetUser()
    }
  }, [id])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Edit User"} breadcrumbItem={"Edit User"} />
          {userData && (
            <UsersInvestorForm
              defaultValues={userData}
              userStatus={userStatus}
              id={id}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditInvestorUsers
